package org.ttt.autogenesis.kvisionapp.mapUpload

import org.ttt.autogenesis.network.*
import kotlinx.serialization.builtins.*

internal fun registerMapUploadErrorClientHandlersRpcHandlers(rpcRegistry : RpcRegistry, target : org.ttt.autogenesis.kvisionapp.mapUpload.MapUploadErrorClientHandlers)
{

    rpcRegistry.registerTyped(
        method = "Map.Upload.Error",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.MapUploadErrorData.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleMapUploadError(ctx, payload)
        null
    }
}

internal class MapUploadErrorClientHandlersRpcHandlersRegistrationProvider(private val target : org.ttt.autogenesis.kvisionapp.mapUpload.MapUploadErrorClientHandlers) : RpcRegistrationProvider
{
    override fun register(rpcRegistry : RpcRegistry)
    {
        registerMapUploadErrorClientHandlersRpcHandlers(rpcRegistry, target)
    }
}

internal val _mapUploadErrorClientHandlersRpcHandlersProvider = MapUploadErrorClientHandlersRpcHandlersRegistrationProvider(org.ttt.autogenesis.kvisionapp.mapUpload.MapUploadErrorClientHandlers).also {
    RpcRegistrationCollector.registerProvider(it)
}
